import React, { useEffect, useRef, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Menu from '../../../../../Layout/Menu/Menu';
import { Navigation, NavigationMobile } from '../../../../Navigation/Menu';
import VipTablesRequests from '../VipTablesRequests';
//import Draggable from "./Draggable";
import Draggable from 'react-draggable';
import NavBar from "../../../../../../components/NavBar";

const TablesDesigner = () => {



    const blocks = [
        { name: "A", color: "blue" },
        { name: "B", color: "pink" },
        { name: "C", color: "green" },
        { name: "D", color: "yellow" },
        { name: "E", color: "purple" }
    ];


    const eventHandler = (e, data) => {
        console.log('Event Type', e.type);
        console.log({ e, data });
    }

    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-sm-12 dashboard-content">
                        <div className="row">
                            <div className="col-12 "></div>
                        </div>
                        <div className="row">
                            {/* {blocks.map((b) => (
                                <Draggable
                                    key={b.name}
                                    
                                >
                                    <div className="block " style={{ backgroundColor: b.color }}>
                                        {b.name}
                                    </div>
                                </Draggable>
                            ))} */}
                        </div>

                        <div className="row">
                            <Draggable
                                bounds="parent"
                                onDrag={eventHandler}
                            >
                                <div style={{ backgroundColor: 'red', width: '50px', height: '50px' }}>&nbsp;</div>
                            </Draggable>
                            <div style={{ backgroundImage: 'url("/img/temp/vip.png")', height: '550px', backgroundRepeat: 'no-repeat' }}>
                                &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </NavBar>
        </div>
    )
}


export default TablesDesigner;